export const SELECT = {
  POSITION: {
    TOP: "top-start",
    BOTTOM: "bottom-start",
  },
  SIZE: { LARGE: "large", MEDIUM: "medium", SMALL: "small" },
};